import { useRouteError, isRouteErrorResponse } from "react-router";

export default function ErrorPage() {
  const error = useRouteError();

  const message = isRouteErrorResponse(error)
    ? error.statusText
    : error instanceof Error
      ? error.message
      : "An unexpected error occurred.";

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background text-center px-4">
      <div className="bg-card rounded-lg shadow-sm border border-border p-8 md:p-12 max-w-md w-full">
        <div className="w-16 h-16 bg-error/10 rounded-full flex items-center justify-center mx-auto mb-6">
          <span className="material-icons-outlined text-3xl text-error">
            error_outline
          </span>
        </div>
        <h2 className="text-2xl font-bold text-foreground">
          Something went wrong!
        </h2>
        <p className="mt-2 text-foreground-secondary mb-6">{message}</p>
        <button
          onClick={() => window.location.reload()}
          className="rounded bg-primary px-6 py-3 text-sm font-bold text-primary-foreground shadow-sm hover:bg-primary-dark transition-all duration-base active:scale-[0.98]"
        >
          Try again
        </button>
      </div>
    </div>
  );
}
